import edapWrapper from '@homeaway/edap-wrapper';
export const edap = edapWrapper();

export const GENERIC_EVENT = 'generic.event';
export const PAGE_VIEW = 'pageview';


export const namedEvents = {
    HEADER_LINK_CLICK: 'header.link.click',
    TRIP_COLLECTION_SELECTED: 'trip_collection.selected',
    CURRENCY_SELECTOR_PRESENTED: 'display_currency_selector.presented',
    CURRENCY_SELECTOR_SELECTED: 'display_currency_selector_details.selected',
    CURRENCY_SET_PRESENTED: 'display_currency_set.presented',
    ALL_CURRENCY_SELECTED: 'display_currency_set.selected',
    CURRENCY_SELECTED: 'display_currency.selected',
    CURRENCY_UPDATED: 'display_currency.updated',
};

export const linkLocations = {
    HEADER_LINK_LOGIN: 'header.login',
    HEADER_LINK_OWNER_LOGIN: 'header.login.owner',
    HEADER_LINK_TRAVELER_LOGIN: 'header.login.traveler',
    SIDEBAR_CURRENCY_SELECTOR: 'sidebar',
    SIDEBAR_TOP_CURRENCY_LIST: 'sidebar_top_displaycurrency_list',
    SIDEBAR_ALL_CURRENCY_LIST: 'sidebar_all_displaycurrency_list'
};
